module.exports = __webpack_public_path__ + "static/media/06.b08b7e02.jpg";